<div class="main">
  <p>Du har försökt att ansöka om att höja dina bolån hos vår samarbetspartner Borgo. Enligt våra uppgifter har du dock
    inga lån hos Borgo. Om du har bolån i Sparbanken Syd ansöker du om att höja dem
    <a href="https://www.sparbankensyd.se/privat/bolan/ansokan-bolan">här</a>.</p>
</div>